<template>
  <el-form-item 
    v-if="visible"
    :label="$t('lang.分') + '：'">
    <el-select
      @change="handleChange"
      :disabled="disabled"
      v-model.number="localValue"
      filterable
      allow-create
      default-first-option
      :placeholder="$t('lang.请选择')">
      <template v-if="devMode && devMode.timeChange">
        <el-option :label="0" :value="0" />
        <el-option
          v-for="t in minuteOptions"
          :key="t"
          :label="t"
          :value="t" />
      </template>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'Minute',
  props: {
    // v-model 绑定的值
    value: {
      type: [Number, String],
      default: null
    },
    devMode: {
      type: Object,
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    },
    minuteTime: {
      type: Function,
      required: true
    }
  },
  computed: {
    visible() {
      return this.permissions.includes('TIME_UNIT');
    },
    disabled() {
      if (!this.permissions.includes('TIME_UNIT')) return true;
      return !this.devMode?.timeChange;
    },
    minuteOptions() {
      if (!this.devMode || !this.devMode.timeChange) return [];
      const options = [];
      const maxMinute = this.minuteTime(this.devMode.maxTime);
      for (let t = 1; t <= maxMinute; t++) {
        if (t >= this.devMode.minTime / 60) {
          options.push(t);
        }
      }
      return options;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('change');
    }
  }
};
</script>

